import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
	selector: 'app-html-block',
	templateUrl: './html-block.component.html',
	styleUrls: ['./html-block.component.scss'],
})
export class HtmlBlockComponent implements OnInit {
	@Input() blockArray;

	@Output() stepChange = new EventEmitter();

	public finalBlock;

	constructor() { }

	ngOnInit() {
		this.finalBlock = this.formatBlock(this.blockArray);
	}

	formatBlock(content) {
		const finalBlock = [];
		let lastBlock = '';
		let listId = 0;
		content.blocks.forEach(
			(block) => {
				const styleBlock = [];
				const entityBlock = [];
				const tempBlock = [];
				if (block.entityRanges.length > 0) {
					block.entityRanges.forEach(
						(item) => {
							// set target
							entityBlock.push({
								data: {
									target: content.entityMap[item.key].data.target === '_blank' ? '_blank' : '_self',
									url: content.entityMap[item.key].data.url,
								},
								length: item.length,
								offset: item.offset,
								style: {},
								text: block.text.substr(item.offset, item.length),
								type: content.entityMap[item.key].type,
							});
						},
					);
				}
				if (block.inlineStyleRanges.length > 0) {
					block.inlineStyleRanges.forEach(
						(item) => {
							// check tempBlock array to see if a range already exists for this style
							let newToken = true;
							let oldIdx = 0;
							let stylePrefix; let
								styleValue;
							switch (item.style) {
								case 'BOLD':
									stylePrefix = 'font-weight';
									styleValue = 500;
									break;
								case 'ITALIC':
									stylePrefix = 'font-style';
									styleValue = 'italic';
									break;
								case 'UNDERLINE':
									stylePrefix = 'text-decoration';
									styleValue = 'underline';
									break;
								default:
									break;
							}
							styleBlock.some(
								(token, idx) => {
									if (token.offset === item.offset && token.length === item.length) {
										oldIdx = idx;
										newToken = false;
										return true;
									}
									return false;
								},
							);
							if (newToken) {
								const newtk = {
									length: item.length,
									offset: item.offset,
									style: {},
									text: block.text.substr(item.offset, item.length),
									type: 'TEXT',
								};
								newtk.style[stylePrefix] = styleValue;
								styleBlock.push(newtk);
							} else {
								styleBlock[oldIdx].style[stylePrefix] = styleValue;
							}
						},
					);
				}
				let lastOffset = 0;
				styleBlock.forEach(
					(style) => {
						if (style.offset === lastOffset) {
							tempBlock.push(style);
							lastOffset += style.length;
						} else {
							const length = style.offset - lastOffset;
							tempBlock.push({
								length,
								offset: lastOffset,
								style: {},
								text: block.text.substr(lastOffset, length),
								type: 'TEXT',
							});
							tempBlock.push(style);
							lastOffset = style.offset + style.length;
						}
					},
				);
				if (lastOffset < block.text.length) {
					tempBlock.push({
						length: block.text.length - lastOffset,
						offset: lastOffset,
						style: {},
						text: block.text.substr(lastOffset),
						type: 'TEXT',
					});
				}
				tempBlock.forEach(
					(item, index, parent) => {
						if (item.text === ' ') {
							parent.splice(index, 1);
						}
					},
				);
				entityBlock.forEach(
					(entity) => {
						if (entity.length > 1) {
							tempBlock.some(
								(token, idx, parent) => {
									if (token.text.indexOf(entity.text) !== -1) {
										if (entity.offset >= token.offset && entity.offset <= token.offset + token.length) {
											if (entity.offset === token.offset && entity.length === token.length) {
												token.data = entity.data;
												token.type = entity.type;
											} else {
												let preToken;
												let postToken;
												let totalLength = 0;
												if (entity.offset !== token.offset) {
													preToken = { ...token };
													preToken.length = entity.offset - token.offset;
													preToken.text = token.text.substr(token.offset, preToken.length);
													totalLength += preToken.length;
												}
												entity.style = token.style;
												totalLength += entity.length;
												if (totalLength < token.length) {
													postToken = { ...token };
													postToken.length = token.length - totalLength;
													postToken.offset = entity.offset + entity.length;
													postToken.text = token.text.substr(totalLength);
												}
												parent.splice(idx, 1);
												if (postToken) {
													parent.splice(idx, 0, postToken);
												}
												parent.splice(idx, 0, entity);
												if (preToken) {
													parent.splice(idx, 0, preToken);
												}
											}
											return true;
										}
										return false;
									}
									return false;
								},
							);
						}
					},
				);
				tempBlock.forEach(
					(item, index, parent) => {
						if (item.text === ' ') {
							parent.splice(index, 1);
						}
						item.text = item.text.trim();
						if (item.data) {
							if (item.data.url.indexOf('https://secure.writtenwordmedia.com/') !== -1) {
								item.data.internal = true;
								item.data.url = item.data.url.replace('https://secure.writtenwordmedia.com/', '/');
							} else {
								item.data.internal = false;
							}
						}
					},
				);
				if (block.type !== 'unordered-list-item' && block.type !== 'ordered-list-item') {
					finalBlock.push({ content: tempBlock, type: block.type, id: -1 });
					lastBlock = block.type;
				} else {
					if (block.type === 'ordered-list-item') {
						if (lastBlock !== 'ordered-list-item') {
							listId += 1;
							finalBlock.push({ content: [], type: 'ordered-list', id: listId });
						}
					}
					if (block.type === 'unordered-list-item') {
						if (lastBlock !== 'unordered-list-item') {
							listId += 1;
							finalBlock.push({ content: [], type: 'unordered-list', id: listId });
						}
					}
					finalBlock.some(
						(listItem) => {
							if (listItem.id === listId) {
								listItem.content.push(tempBlock);
								return true;
							}
							return false;
						},
					);
					lastBlock = block.type;
				}
			},
		);
		return finalBlock;
	}

	handleStepChange(event) {
		this.stepChange.emit(event);
	}
}
